import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  desktopActions: {
    marginLeft: '10px',
    display: 'flex',
    '& .modal-trigger': {
      marginRight: '5px'
    },
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'none'
    }
  },
  tabletActions: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginTop: '10px',
      display: 'block'
    }
  }
});
export default useStyles;